import axios from "axios";
import { toast } from "react-toastify";

import GlobalUrls from '../../Utilities/General/Urls'
import { getToken } from '../../Utilities/Auth/AuthPermissions';
import { errorTimeout, networkError, serverError, expiredSession } from '../../Utilities/General/StatusHandler';

const CalGroupService = {

    getCalGroups: async build => {
        try {
            let url = GlobalUrls.urlCalGroup + `?calibration__calibration_build=${build}&limit=1000&offset=0`;
            let allResults = [];
            let visitedUrls = new Set();

            while (url) {
                if (visitedUrls.has(url)) {
                    throw new Error('Pagination loop detected');
                }

                visitedUrls.add(url);

                const { data } = await axios.get(url, { headers: { Authorization: getToken() } });

                if (Array.isArray(data)) {
                    return data;
                }

                if (!Array.isArray(data.results)) {
                    throw new Error('Invalid paginated response');
                }

                allResults = allResults.concat(data.results);
                url = data.next;
            }

            return allResults;
        } catch (err) {
            if (err.message.includes('Network Error')) return networkError();
            if (err.message.includes('500')) return serverError();
            if (err.message.includes('504')) return errorTimeout();
            if (err.message.includes('401') && !toast.isActive('expiredSessionToast')) return expiredSession();

            throw err;
        }
    },

    getCalPureTone: async group => {
        try {
            const { data } = await axios.get(
                GlobalUrls.urlCalPureTone + `?calibration_group=${group}`,
                { headers: { Authorization: getToken() } }
            )
            return data
        } catch (err) {
            if (err.message.includes('Network Error')) return networkError()
            if (err.message.includes('500')) return serverError()
            if (err.message.includes('504')) return errorTimeout()
            if (err.message.includes('401') && !toast.isActive('expiredSessionToast')) return expiredSession()
        }
    },

    saveNewCalPureTone: async newData => {
        try {
            const { data } = await axios.post(
                GlobalUrls.urlCalPureTone,
                newData,
                { headers: { Authorization: getToken() } }
            )
            return data
        } catch (err) {
            if (err.message.includes('Network Error')) return networkError()
            if (err.message.includes('500')) return serverError()
            if (err.message.includes('504')) return errorTimeout()
            if (err.message.includes('401') && !toast.isActive('expiredSessionToast')) return expiredSession()
        }
    },

    updateCalPureTone: async (id, updatedData) => {
        try {
            const { data } = await axios.put(
                GlobalUrls.urlCalPureTone + `${id}`,
                updatedData,
                { headers: { Authorization: getToken() } }
            )
            return data
        } catch (err) {
            if (err.message.includes('Network Error')) return networkError()
            if (err.message.includes('500')) return serverError()
            if (err.message.includes('504')) return errorTimeout()
            if (err.message.includes('401') && !toast.isActive('expiredSessionToast')) return expiredSession()
        }
    },

    deleteCalPureTone: async id => {
        try {
            await axios.delete(
                GlobalUrls.urlCalPureTone + `${id}`,
                { headers: { Authorization: getToken() } }
            )
        } catch (err) {
            if (err.message.includes('Network Error')) return networkError()
            if (err.message.includes('500')) return serverError()
            if (err.message.includes('504')) return errorTimeout()
            if (err.message.includes('401') && !toast.isActive('expiredSessionToast')) return expiredSession()
        }
    },

    getCalLogo: async group => {
        try {
            const { data } = await axios.get(
                GlobalUrls.urlCalLogo + `?calibration_group=${group}`,
                { headers: { Authorization: getToken() } }
            )
            return data
        } catch (err) {
            if (err.message.includes('Network Error')) return networkError()
            if (err.message.includes('500')) return serverError()
            if (err.message.includes('504')) return errorTimeout()
            if (err.message.includes('401') && !toast.isActive('expiredSessionToast')) return expiredSession()
        }
    },

    updateCalLogo: async (id, updatedData) => {
        try {
            const { data } = await axios.put(
                GlobalUrls.urlCalLogo + `${id}`,
                updatedData,
                { headers: { Authorization: getToken() } }
            )
            return data
        } catch (err) {
            if (err.message.includes('Network Error')) return networkError()
            if (err.message.includes('500')) return serverError()
            if (err.message.includes('504')) return errorTimeout()
            if (err.message.includes('401') && !toast.isActive('expiredSessionToast')) return expiredSession()
        }
    },

    getNoiseParameters: async calibration => {
        try {
            const { data } = await axios.get(
                GlobalUrls.urlCal + `${calibration}/`,
                { headers: { Authorization: getToken() } }
            )
            return data
        } catch (err) {
            if (err.message.includes('Network Error')) return networkError()
            if (err.message.includes('500')) return serverError()
            if (err.message.includes('504')) return errorTimeout()
            if (err.message.includes('401') && !toast.isActive('expiredSessionToast')) return expiredSession()
        }
    }

}

export default CalGroupService